import { TablePaginationConfig } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { useState } from 'react';
import invariant from 'tiny-invariant';

import { useAppContext } from 'business/contextProviders/useAppContext';
import {
  SteeringTableParamsProps,
  useGetDataQuery,
} from 'business/steering/hooks/use-get-steering-data-query';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringTable } from 'business/steering/pages/table-page/components/steering-table';
import { UpdateSteeringModal } from 'business/steering/pages/table-page/components/update-steering-modal';
import { SteeringDataFields } from 'business/steering/pages/table-page/types';
import { GetSteeringDataQuery } from 'generated/graphql';
import { FilterDataSetter } from 'technical/filter-data';

interface Props {
  tableParams: SteeringTableParamsProps;
  onChange?: (
    pagination: TablePaginationConfig,
    _: unknown,
    sorter:
      | SorterResult<SteeringDataFields>
      | SorterResult<SteeringDataFields>[],
  ) => void;
  setFilterData: FilterDataSetter<SteeringTableFilterData>;
}

export const SteeringTableContainer = ({
  tableParams,
  onChange,
  setFilterData,
}: Props) => {
  const { currentConstructionSiteId: constructionSiteId } = useAppContext();
  invariant(constructionSiteId, 'No construction site id');

  const [currentRecord, setCurrentRecord] = useState<
    GetSteeringDataQuery['parameter_ring'][number] | null
  >(null);
  const isModalVisible = currentRecord !== null;

  const { data, loading } = useGetDataQuery({
    constructionSiteId,
    tableParams,
    setFilterData,
  });

  const openEditModal = (id: string | null) => {
    const ring = data?.parameter_ring.find((r) => r.id === id) || null;
    setCurrentRecord(ring);
  };

  const closeEditModal = () => {
    setCurrentRecord(null);
  };

  return (
    <>
      <SteeringTable
        data={data?.parameter_ring}
        loading={loading}
        pagination={{
          ...tableParams,
          total: data?.parameter_ring_aggregate.aggregate?.count,
        }}
        onChange={onChange}
        onEditionClick={openEditModal}
      />
      <UpdateSteeringModal
        isModalVisible={isModalVisible}
        closeModal={closeEditModal}
        ring={currentRecord}
      />
    </>
  );
};
